import { PrefilledAttributeValidation } from "@idw-types/common/prefilled-attribute-validation";
import { validateYear } from "@utils/self-service/prefilled-attribute-validation-util";
import { isValidPhoneNumber } from "libphonenumber-js";

export const SSN9_ATTRIBUTE_TYPE_FIELD_ID = '500';
export const SSN4_ATTRIBUTE_TYPE_FIELD_ID = '2700';
export const FULL_NAME_ATTRIBUTE_TYPE_ID = '1';
export const ADDRESS_ATTRIBUTE_TYPE_ID = '67';
export const TELEPHONE_ATTRIBUTE_TYPE_ID = '68';
export const EMAIL_ATTRIBUTE_TYPE_FIELD_ID = '800';
export const PHYSICIAN_LICENSE_ATTRIBUTE_TYPE_FIELD_ID = '77000';
export const DOB_ATTRIBUTE_TYPE_ID = '6';

export const FULL_NAME_ATTRIBUTE_TYPE_FIELD_IDs = {
    FIRST_NAME: '100',
    MIDDLE_NAME: '101',
    LAST_NAME: '102',
    SUFFIX: '103'
}

export const ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs = {
    STREET_NUMBER: '6700',
    STREET_NAME: '6701',
    SUB_PREMISE: '6702',
    LOCALITY: '6709',
    POSTCODE: '6710',
    COUNTRY: '6715',
    ADMINISTRATIVE_AREA_LEVEL_1: '6711'
}
export const DOB_ATTRIBUTE_TYPE_FIELD_IDs = {
    day: '600',
    month: '601',
    year: '602'
}
export const DATE_ATTRIBUTE_TYPE_FIELD_IDs = {
    day: '4300',
    month: '4301',
    year: '4302'
}
export const TELEPHONE_ATTRIBUTE_TYPE_FIELD_IDs = {
    dialCode: '6800',
    phone: '6801'
}


export const NATIONALITY_ATTRIBUTE_TYPE_FIELD_ID = '901';

export const EXCLUDED_ATTRIBUTE_ADDRESS_FIELDS_IDS = ['6703', '6704', '6705', '6706', '6707', '6708', '6712', '6713', '6714'];
export const GENERIC_REQUIRED_MESSAGE = '{{param}} field is required, please select a value';
export const CUSTOM_ATTR_GENERIC_REQUIRED_MESSAGE = '{{param}} field is required, please enter a value';
const DEFAULT_MAX_LENGTH = 25;

export const ATTRIBUTE_TYPE_FIELD_VALIDATIONS: { [key: string]: PrefilledAttributeValidation } = {
    [DOB_ATTRIBUTE_TYPE_FIELD_IDs.day]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 2,
        pattern: /(0[1-9]|[12]\d|3[01])/,
        patternErrorMessage: () => 'Please enter a valid 2 digits Day (Spaces and special characters are not allowed) '
    },
    [DOB_ATTRIBUTE_TYPE_FIELD_IDs.month]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 2,
        pattern: /^(0[1-9]|1[012])$/,
        patternErrorMessage: () => 'Please enter a valid 2 digits Month (Spaces and special characters are not allowed)'
    },
    [DOB_ATTRIBUTE_TYPE_FIELD_IDs.year]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 4,
        pattern: /^\d{4}$/,
        patternErrorMessage: () => 'Please enter a valid 4 digits Year (Spaces and special characters are not allowed)',
        customValidator: (value: number) => validateYear(value),
        customValidatorErrorMessage: 'Please enter a valid 4 digits Year (Spaces and special characters are not allowed)'
    },
    [DATE_ATTRIBUTE_TYPE_FIELD_IDs.day]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 2,
        pattern: /(0[1-9]|[12]\d|3[01])/,
        patternErrorMessage: () => 'Please enter a valid 2 digits Day (Spaces and special characters are not allowed) '
    },
    [DATE_ATTRIBUTE_TYPE_FIELD_IDs.month]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 2,
        pattern: /^(0[1-9]|1[012])$/,
        patternErrorMessage: () => 'Please enter a valid 2 digits Month (Spaces and special characters are not allowed)'
    },
    [DATE_ATTRIBUTE_TYPE_FIELD_IDs.year]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 4,
        pattern: /^\d{4}$/,
        patternErrorMessage: () => 'Please enter a valid 4 digits Year (Spaces and special characters are not allowed)',
        customValidator: (value: number) => validateYear(value),
        customValidatorErrorMessage: 'Please enter a valid 4 digits Year (Spaces and special characters are not allowed)'
    },
    [EMAIL_ATTRIBUTE_TYPE_FIELD_ID]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 50,
        requiredErrorMessage: () => 'Enter a valid recipient email address.',
        pattern: /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/,
        patternErrorMessage: () => 'Enter a valid recipient email address.'
    },
    [ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs.ADMINISTRATIVE_AREA_LEVEL_1]: {
        isRequired: (isParentRequired: boolean) => isParentRequired
    },
    [ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs.STREET_NAME]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z0-9-'\s]{0,25}$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (special characters are not allowed except ' and -)`
    },
    [ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs.STREET_NUMBER]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z0-9-'\s]{0,25}$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (special characters are not allowed except ' and -)`

    },
    [ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs.LOCALITY]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z-'\s]{0,25}$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (Numbers & special characters are not allowed except ' and -)`
    },
    [ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs.SUB_PREMISE]: {
        isRequired: () => false,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z0-9-'\s]*$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (special characters are not allowed except ' and -)`
    },
    [ADDRESS_ATTRIBUTE_TYPE_FIELD_IDs.POSTCODE]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 5,
        pattern: /^\d{5}$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (Only numbers are allowed, without spaces)`
    },
    [TELEPHONE_ATTRIBUTE_TYPE_FIELD_IDs.dialCode]: {
        isRequired: (isParentRequired: boolean) => isParentRequired
    },
    [TELEPHONE_ATTRIBUTE_TYPE_FIELD_IDs.phone]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        phoneValidator: (phoneString: string) => !isValidPhoneNumber(phoneString),
        phoneValidatorErrorMessage: "Please enter a valid phone number"
    },
    [SSN9_ATTRIBUTE_TYPE_FIELD_ID]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 9,
        pattern: /^\d{9}$/,
        patternErrorMessage: () => `Enter a valid 9 digits Social Security Number (Only numbers are allowed, without spaces).`
    },
    [SSN4_ATTRIBUTE_TYPE_FIELD_ID]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: 4,
        pattern: /^\d{4}$/,
        patternErrorMessage: () => `Enter a valid 4 digits Social Security Number (Only numbers are allowed, without spaces).`
    },
    [FULL_NAME_ATTRIBUTE_TYPE_FIELD_IDs.FIRST_NAME]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: DEFAULT_MAX_LENGTH
    },
    [FULL_NAME_ATTRIBUTE_TYPE_FIELD_IDs.MIDDLE_NAME]: {
        isRequired: () => false,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z-'\s]{0,25}$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (up to 25 characters with no special characters)`
    },
    [FULL_NAME_ATTRIBUTE_TYPE_FIELD_IDs.LAST_NAME]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: DEFAULT_MAX_LENGTH
    },
    [FULL_NAME_ATTRIBUTE_TYPE_FIELD_IDs.SUFFIX]: {
        isRequired: () => false,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z-'\s]{0,25}$/,
        patternErrorMessage: (param: string) => `Please enter a valid ${param} (up to 25 characters with no special characters)`
    },
    [PHYSICIAN_LICENSE_ATTRIBUTE_TYPE_FIELD_ID]: {
        isRequired: (isParentRequired: boolean) => isParentRequired,
        maxLength: DEFAULT_MAX_LENGTH,
        pattern: /^[a-zA-Z0-9]{0,25}$/,
        patternErrorMessage: () => `Enter a valid Physician License Number (Spaces & special characters are not allowed).`
    },
    [NATIONALITY_ATTRIBUTE_TYPE_FIELD_ID]: {
        isRequired: (isParentRequired: boolean) => isParentRequired
    }
}